import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Product.scss';

export default function Gpu() {
  const [gpus, setGpus] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // Фильтруем по категории "gpu"
        const gpuItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'gpu'
        );

        setGpus(gpuItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="gpu">
      <h1>Видеокарты</h1>
      <div className="gpu__list">
        {gpus.length > 0 ? (
          gpus.map((gpu) => (
            <div key={gpu.id} className="gpu__card">
              <img src={gpu.image} alt={gpu.name} />
              <h2>{gpu.name}</h2>
              <p className="specs">{gpu.description}</p>
              <p className="price">{gpu.price}</p>
              <Link to={`/components/gpu/${gpu.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
